import { SortConfig, VirtualTable } from '@components/ui/VirtualTable';
import { useTranslation } from 'react-i18next';
import { AffiliatesCommission } from '../../models/Affiliates';
import { Badge } from '@shared/components/ui/badge/Badge';
import { formatCurrencyAmount, useCurrency } from '../../../../Orders/shared/hooks/useCurrency';
// import { DropdownActions } from '../interaction/DropdownActions';

interface TableProps {
  affiliates: AffiliatesCommission[];
  isLoading?: boolean;
  className?: string;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  sorting?: any;
  onSortingChange?: (sorting: any) => void;
}

export const Table = ({
  affiliates,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  sorting,
  onSortingChange,
}: TableProps) => {
  const { t } = useTranslation('affiliatesModule');
  const currencyCode = useCurrency();

  const handleSortingChange = (newSorting: SortConfig | null) => {
    onSortingChange?.(newSorting);
  };

  const columns = [
    {
      header: t('table.product'),
      accessorKey: 'stripe_invoice_id',
      size: 20,
      cell: ({ row }: any) => (
        <span className="text-sm font-medium">{'****' + row.original.stripe_invoice_id.slice(-6)}</span>
      ),
    },
    {
      header: t('table.amount'),
      accessorKey: 'stripe_invoice_amount',
      size: 20,
      cell: ({ row }: any) => (
        <span className="text-sm font-medium">
          {formatCurrencyAmount(row.original.stripe_invoice_amount, currencyCode)}
        </span>
      ),
    },
    {
      header: t('table.total'),
      accessorKey: 'commission_amount',
      size: 20,
      cell: ({ row }: any) => (
        <span className="text-primary font-medium">
          {formatCurrencyAmount(row.original.commission_amount, currencyCode)}
        </span>
      ),
    },
    {
      header: t('table.description'),
      accessorKey: 'status',
      size: 20,
      cell: () => (
        <Badge variant="transparent-orange" className="text-warning">
          Pendiente
        </Badge>
      ),
    },
    {
      header: t('table.date'),
      accessorKey: 'date',
      size: 20,
      cell: () => <span className="text-sm font-medium">01/06/2025</span>,
    },
  ];

  return (
    <div className="w-full">
      <VirtualTable
        data={affiliates}
        columns={columns}
        autoHeight={true}
        maxHeight={affiliates.length <= 10 ? `${affiliates.length * 70 + 120}px` : 'calc(100vh - 150px)'}
        minHeight="120px"
        rowHeight={70}
        emptyMessage={t('empty.message')}
        className="rounded-lg shadow-sm"
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        infiniteScrollThreshold={500}
        sorting={sorting}
        onSortingChange={handleSortingChange}
      />
    </div>
  );
};
